import { MaterialSymbol } from 'react-material-symbols'

import { Button } from 'primereact/button'

import { ControlInformation } from '../../data/models/_generatedUblInvoice'
import i18n from '../../utils/i18n'

export const TestAndSourceBodyTemplate = (
  trialFlag?: ControlInformation['trialFlag'],
  processingType?: ControlInformation['processingType'],
) => {
  return (
    <>
      {/* Test */}
      {trialFlag && (
        <Button
          icon={<MaterialSymbol icon="science" size={20} />}
          className="p-button-text"
          size="small"
          tooltip={i18n.t(
            'eInvoiceOverview.table.columns.testAndSource.options.type.tooltips.test',
          )}
          rounded
        />
      )}

      {/* Portal */}
      {processingType === 'WEB' && !trialFlag && (
        <Button
          icon={<MaterialSymbol icon="language" size={20} />}
          className="p-button-text p-mr-2"
          size="small"
          tooltip={i18n.t(
            'eInvoiceOverview.table.columns.testAndSource.options.type.tooltips.web',
          )}
          rounded
        />
      )}

      {/* Mail */}
      {processingType === 'API' && !trialFlag && (
        <Button
          icon={<MaterialSymbol icon="mail" size={20} />}
          className="p-button-text p-mr-2"
          size="small"
          tooltip={i18n.t(
            'eInvoiceOverview.table.columns.testAndSource.options.type.tooltips.mail',
          )}
          rounded
        />
      )}
    </>
  )
}
